import { useMemo } from 'react';

import qs from 'qs';

import { useTracking } from '@change-corgi/core-react/tracking';

import { useImpactStoryPageData } from '#src/app/pages/impactStory/pageContext';
import { generateAiSapParam } from '#src/app/shared/utils/sap';

type Result = ModelHookResult<
	{
		sapImage: string;
		sapUrl: string;
		sapAiUrl: string;
	},
	{
		trackSapClick: () => void;
		trackSapAiClick: () => void;
	}
>;

export function useSapContainer(): Result {
	const {
		data: {
			featureConfig: {
				story: { sapImage },
			},
			aiSapId,
		},
	} = useImpactStoryPageData();
	const track = useTracking();

	const sapAiUrl = useMemo(
		() =>
			`/start-a-petition/intro?${qs.stringify({ state: generateAiSapParam(aiSapId), source_location: 'impact_story_page_SAP_AI' })}`,
		[aiSapId],
	);

	return {
		data: {
			sapImage,
			sapUrl: '/start-a-petition/intro?source_location=impact_story_page_SAP',
			sapAiUrl,
		},
		actions: {
			trackSapClick: () => {
				void track('impact_story_page_SAP_click', {
					cta: 'sap',
				});
			},
			trackSapAiClick: () => {
				void track('impact_story_page_SAP_click', {
					cta: 'sap_AI',
				});
			},
		},
	};
}
